import { Box } from "@chakra-ui/react";
import logo from "./TT.svg";

const getLineColor = () => {
  // Check localStorage or body class for dark mode
  if (
    (typeof window !== "undefined" && localStorage.getItem("theme") === "dark") ||
    (typeof document !== "undefined" && document.body.classList.contains("dark")) ||
    (typeof document !== "undefined" && document.documentElement.getAttribute("data-theme") === "dark")
  ) {
    return "#fff";
  }
  return "#232a36"; // dark gray for light mode
};

const LogoSeparator = () => {
  const borderColor = getLineColor();

  return (
    <Box textAlign="center " className="mt-3">
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box
          className="mt-4"
          flex="1"
          borderBottom={`2px solid ${borderColor}`}
          mr="2.5rem"
        />
        <img
          src={logo}
          alt="Website Logo"
          width="120"
          height="90"
          style={{
            width: '120px',
            height: '90px',
            display: 'block',
            aspectRatio: '4/3'
          }}
          loading="eager"
        />
        <Box
          flex="1"
          className="mt-4"
          borderBottom={`2px solid ${borderColor}`}
          ml="1rem"
        />
      </Box>
    </Box>
  );
};

export default LogoSeparator;
